import { render, staticRenderFns } from "./hotelList.vue?vue&type=template&id=05881bb8&scoped=true&"
import script from "./hotelList.vue?vue&type=script&lang=js&"
export * from "./hotelList.vue?vue&type=script&lang=js&"
import style0 from "./hotelList.vue?vue&type=style&index=0&id=05881bb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05881bb8",
  null
  
)

export default component.exports